<template>
<div id="note" class="col-lg-10">
  <div v-if="isLogged">
    <div class="messageUpdateNote">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        {{ updateNoteMessage }}
      </b-alert>
    </div>
    <div v-if="isSelectedNote">
      <p><input type="text" id="nomNote" name="nomNote" value=""> <i @click="validerNomNote()" class="fas fa-check"></i> <i @click="annulerNomNote()" class="fas fa-times"></i> <span @click="editNomNote()" class="titreNote">{{ noteName }}</span><span class="dateCreationNote">(crée le {{ noteDateCreation }})</span><span @click="deleteNoteIntercalaire()" class="fas fa-trash-alt"></span></p>
      <div class="textNote">
        <div class="editor">
          <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="menubar">
                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.bold() }"
                @click="commands.bold"
                >
                <i class="fas fa-bold"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.italic() }"
                @click="commands.italic"
                >
                <i class="fas fa-italic"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.strike() }"
                @click="commands.strike"
                >
                <i class="fas fa-strikethrough"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.underline() }"
                @click="commands.underline"
                >
                <i class="fas fa-underline"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.code() }"
                @click="commands.code"
                >
                <i class="fas fa-code"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.paragraph() }"
                @click="commands.paragraph"
                >
                <i class="fas fa-paragraph"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                @click="commands.heading({ level: 1 })"
                >
                <i>Titre 1</i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                @click="commands.heading({ level: 2 })"
                >
                <i>Titre 2</i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                @click="commands.heading({ level: 3 })"
                >
                <i>Titre 3</i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.bullet_list() }"
                @click="commands.bullet_list"
                >
                <i class="fas fa-list-ul"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.ordered_list() }"
                @click="commands.ordered_list"
                >
                <i class="fas fa-list-ol"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.blockquote() }"
                @click="commands.blockquote"
                >
                <i class="fas fa-quote-right"></i>
                </button>

                <button
                class="menubar__button"
                :class="{ 'is-active': isActive.code_block() }"
                @click="commands.code_block"
                >
                <i class="fas fa-code"></i>
                </button>

                <button
                class="menubar__button"
                @click="commands.undo"
                >
                <i class="fas fa-undo"></i>
                </button>

                <button
                class="menubar__button"
                @click="commands.redo"
                >
                <i class="fas fa-redo"></i>
                </button>
            </div>
          </editor-menu-bar>
          <div class="row">
              <button @click="editNote()" class="btn enregistrerNote">Enregistrer</button>
              <button @click="printNote()" class="btn imprimerNote">Imprimer</button>
          </div>
          <editor-content class="editor__content zoneText" :editor="editor" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// Add dependency to AXIO JavaScript library
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import { bus } from './../../event-bus.js'
import $ from 'jquery'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  name: 'note',
  components: {
    EditorContent,
    EditorMenuBar
  },
  computed: mapGetters([
    'isLogged'
  ]),
  data: () => {
    return {
      noteId: '',
      sectionId: '',
      noteName: '',
      noteDateCreation: '',
      isSelectedNote: false,
      updateNoteMessage: '',
      dismissSecs: 4,
      dismissCountDown: 0,
      content: '',
      editor: null
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  },
  mounted () {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History()
      ]
    })
  },
  created () {
    bus.$on('selectedNote', (intercalaireId) => {
      if (intercalaireId.length === 0) {
        this.editor.destroy()
      }
      if (intercalaireId.length !== 0) {
        let aIntercalaireId = intercalaireId.split('#')
        this.noteId = aIntercalaireId[0]
        this.sectionId = aIntercalaireId[1]

        // Récupérer une note via API :
        axios.get('notes/' + this.noteId)
          .then(response => {
            this.isSelectedNote = true
            this.noteName = response.data.note.name
            this.noteDateCreation = response.data.note.date_creation
            this.editor.setContent(response.data.note.text)
          })
          /*
          .catch(error => {
            console.log(error)
          })
          */
      }
    })
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showUpdate () {
      this.dismissCountDown = this.dismissSecs
    },
    editNomNote () {
      let titreNote = $('.titreNote').text()
      $('#nomNote').val(titreNote)
      $('.titreNote').hide()
      $('#nomNote').show()
      $('#nomNote').focus()
      $('.fa-check').show()
      $('.fa-times').show()
    },
    annulerNomNote () {
      $('#nomNote').hide()
      $('.fa-check').hide()
      $('.fa-times').hide()
      $('.titreNote').show()
    },
    validerNomNote () {
      let renameNote = $('#nomNote').val()
      if (renameNote !== '' && renameNote.length < 30) {
        axios.post('notes/' + this.noteId + '/rename', {
          nom_note: $('#nomNote').val()
        })
          .then(response => {
            if (response.data.status === 0) {
              $('.titreNote').text($('#nomNote').val())
              $('#nomNote').hide()
              $('.fa-check').hide()
              $('.fa-times').hide()
              $('.titreNote').show()

              bus.$emit('updateIntercalaire', this.sectionId)
            }
          })
          /*
          .catch(error => {
            console.log(error)
          })
          */
      }
    },
    editNote () {
      this.updateNoteMessage = ''

      // Sauvegarder les modifications d'une note
      axios.put('notes/' + this.noteId, {
        noteText: this.editor.getHTML()
      })
        .then(response => {
          this.updateNoteMessage = response.data.status_message
          this.showUpdate()
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    },
    printNote () {
      window.print()
    },
    deleteNoteIntercalaire () {
      this.updateNoteMessage = ''

      // Supprimer une note via API :
      axios.delete('notes/' + this.noteId + '/intercalaire/' + this.sectionId)
        .then(response => {
          this.updateNoteMessage = response.data.status_message
          this.showUpdate()
          this.isSelectedNote = false

          bus.$emit('updateIntercalaire', this.sectionId)
        })
        /*
        .catch(error => {
          console.log(error)
        })
        */
    }
  }
}
</script>

<style scoped>
  .zoneText {
    border:1px solid blueviolet;
    padding:3px;
    text-align: left;
  }

  .enregistrerNote {
    margin-left: 25px;
    margin-bottom: 15px;
    margin-top: 15px;
    background-color: white;
    color: blueviolet;
  }

  .imprimerNote {
    margin-left: 25px;
    margin-bottom: 15px;
    margin-top: 15px;
    background-color: white;
    color: blueviolet;
  }

  .titreNote {
    font-size: 24px;
    font-weight: bold;
    color: #e0da1b;
    cursor: pointer;
  }

  #nomNote {
    display: none;
    border: 0px;
    background-color: #e0da1b;
    color: blueviolet;
  }

  .fa-check {
    display: none;
    color: black;
    cursor: pointer;
  }

  .fa-check:hover {
    color: green;
  }

  .fa-times {
    display: none;
    color: black;
    cursor: pointer;
  }

  .fa-times:hover {
    color: red;
  }

  .menubar {
    margin-left: auto;
    margin-right: auto;
  }

  .menubar i {
    margin-right: 20px;
  }

  .fa-trash-alt {
    margin-left: 50px;
  }

  .fa-trash-alt:hover {
    color: red;
    cursor: pointer;
  }

  .menubar__button {
    background-color: white;
    margin-left: 5px;
  }

  .menubar i {
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
  }

  .messageUpdateNote {
    margin-top: 10px;
  }

  .dateCreationNote {
    margin-left: 1%;
  }

  @media screen and (max-width: 600px) {
    .dateCreationNote {
      font-size: 0vw;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    .dateCreationNote {
      font-size: 1.5vw;
    }
  }

  @media screen and (min-width: 1024px) {
    .dateCreationNote {
      font-size: 0.75vw;
    }
  }

  @media print {
    #note .menubar {
      display: none;
    }

    #note .fa-trash-alt {
      display: none;
    }

    #note .row {
      display: none;
    }

    .zoneText {
      border:0px solid white;
      font-size: 3vw;
    }

    .dateCreationNote {
      display: none;
    }

    .titreNote {
      font-size: 6vw;
    }
  }
</style>
